import React, { useEffect, useRef, useState } from 'react'

import clsx from 'clsx'
import moment from 'moment-jalaali'
import { useSelector } from 'react-redux'
import { VisaStatus } from 'src/components/VisaStatus/VisaStatus'
import { VisaItemType } from 'src/types'
import { CrewVisaOperations } from './CrewVisaOperations'
import { useTranslation } from 'react-i18next'
import DatePicker from "react-multi-date-picker";
import DateObject from 'react-date-object'
import { getRemainingTime } from 'src/utils/new'
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { useMutation } from 'react-query'
import { Post } from 'src/apis/api'
import Loading from 'src/components/Loading'
import { toast } from 'react-toastify'
import { Close, EditIcon, EyeIcon, PenIcon, TurnIcon } from 'src/icons/icons'
// import DatePicker from '../../../UI/customDatePickerTime/customDatePickerTime'

export const ActiveVisaRow = (record: VisaItemType & { onSuccessMutate: Function, crewData?: VisaItemType }) => {

    const { subject, automation_number, created_at, agent, id, visa, crews, onSuccessMutate, crewData, crew_visa_detail } = record

    const targetCrewDetail = crew_visa_detail?.find(i => i?.crew_id == crews?.[0].crew_id)

    const [mode, setMode] = useState<'EDIT' | 'VIEW'>('VIEW')

    const [dates, setDates] = useState<{ residence: Date | null, cross: Date | null, passportPhoto: string | File | null }>({
        residence: null,
        cross: null,
        passportPhoto: null
    })

    useEffect(() => {
        if (targetCrewDetail) {
            const { full_expired_at, expired_at, passport_photo_file = null } = targetCrewDetail
            setDates({ residence: moment(expired_at).toDate() ?? null, cross: moment(full_expired_at).toDate() ?? null, passportPhoto: passport_photo_file ?? null })
        }
    }, [targetCrewDetail])

    const exprireDatePickerRef = useRef<HTMLLinkElement>(null)

    const user = useSelector((state) => (state as any).user.user)

    const lng = useSelector((state) => (state as any).common.lng)

    const isAgent = user?.role_key === "agent"

    const isAdmin = user?.role_key === "super_admin"

    const { t } = useTranslation()

    const RenderRemainTime = ({ date }: { date: string | null }) => {

        if (!date) return '-'
        const { day, hour, isPassed, minute } = getRemainingTime(date)

        const suffix = isPassed ? 'گذشته' : 'مانده'

        const className = isPassed ? 'text-red font-bold' : 'text-green-500 font-bold'

        const fullExperesion = clsx(day && `${day} روز و`, `${hour} ساعت و `, `${minute} دقیقه`)

        if (day > 0)
            return <span className={className} title={fullExperesion}>{day} روز  {suffix} </span>

        else if (hour > 0)
            return <span className={className} title={fullExperesion}>{hour} ساعت  {suffix}</span>

        else if (minute > 0)
            return <span className={className} title={fullExperesion}>{minute} دقیقه  {suffix}</span>

        return '-'
    }

    const { mutate, isLoading } = useMutation({
        mutationFn: () => {

            if (Object.values(dates).filter(i => !!i).length != 3) {

                toast.error(t('PleaseFillAllFields'))

                return Promise.reject()
            }

            const formData = new FormData()

            formData.append('form', 'agent_update')


            if (dates?.residence && dates?.cross) {

                formData.append('crews[0][expired_at]', moment(dates?.residence).locale('en').format('YYYY-MM-DD'))
                formData.append('crews[0][full_expired_at]', moment(dates?.cross).locale('en').format('YYYY-MM-DD'))
                formData.append('crews[0][crew_id]', crews?.[0].crew_id)
            }
            if (dates?.passportPhoto instanceof File)
                formData.append('crews[0][passport_photo_file]', dates?.passportPhoto ?? '')


            return Post(`/agent/visas/update/${id}`, formData)
        }

        ,
        mutationKey: ['ChangeDates', id],
        onSuccess: (res: any) => {
            toast.success(res?.msg);
            onSuccessMutate()
            setMode('VIEW')
        },
        onError: (error: any) => {
            toast.error(error?.data?.message || error?.data?.msg);
        },
    })


    // const isEqualToRecent =
    //     dates.cross instanceof Date && moment(dates.cross).format('YYYY-MM-DD') == full_expired_at?.split(' ')[0]
    //     &&
    //     dates.residence instanceof Date && moment(dates.residence).format('YYYY-MM-DD') == expired_at?.split(' ')[0]

    useEffect(() => {
        if (mode == 'EDIT') {

        }
    }, [mode])

    console.log({ dates })

    const backToViewMode = () => {
        // if (targetCrewDetail) {
        // const { full_expired_at = null, expired_at, passport_photo_file = null } = targetCrewDetail
        setDates({
            residence:
                targetCrewDetail?.expired_at ? moment(targetCrewDetail?.expired_at).toDate() : null
            , cross: targetCrewDetail?.full_expired_at ? moment(targetCrewDetail?.full_expired_at).toDate() : null
            , passportPhoto: targetCrewDetail?.passport_photo_file ? targetCrewDetail.passport_photo_file : null
        })
        // }
        setMode('VIEW')
    }

    if (crews.filter(i => !!i.crew).length != 0) {

        const { job, crew: { name, last_name, nationality }, visa: { status }, agent_visa_id, crew_id } = crews?.[0] ?? {}

        return (
            <div className='border rounded-xl border-gray-400  flex flex-col  gap-2 mx-4 p-2 '>

                <div key={id} className={clsx(`grid items-center w -full  `, isAgent ? 'grid-cols-10' : 'grid-cols-11')} >


                    <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {id}
                        </div>
                    </div>
                    {/*<div className="p-3 text-center">*/}
                    {/*  <div className={"text-gray-500 text-sm mt-1"}>*/}
                    {/*    {item?.crew?.nationality}*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div className="p-3 text-center col-span-1">
                        <div className={"text-primary-400 text-sm mt-1 "}>
                            {(visa as any)?.[`${lng}_name`]}
                        </div>
                    </div>
                    {!isAgent && <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {(agent?.name ?? '-') + " " + (agent?.last_name ?? '-')}
                        </div>
                    </div>}
                    <div className="p-3 text-center col-span-1">
                        <div className={clsx("text-gray-500 text-sm mt-1", crews.length > 1 && 'text-red')}>
                            {name ?? '-'}{last_name} {crews.length > 1 && <span className='' dir='ltr'>/ {(crews.length)} Crews /</span>}
                        </div>
                    </div>

                    <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {nationality ?? "-"}
                        </div>
                    </div>

                    <div className="py-3 text-center col-span-1 text-gray-500 flex flex-row justify-center w-full items-center ">

                        {!visa.duplicate ? <DatePicker
                            value={dates.residence}
                            onChange={(e) => e ? setDates({ ...dates, residence: e.toDate() }) : undefined}
                            className='border'
                            inputClass={clsx('text-center rounded-lg w-full flex-none', mode == 'VIEW' ? 'border-transparent' : 'border !border-primary-300 ')}
                            containerClassName='odd'
                            calendar={persian}
                            format={"YYYY/MM/DD"}
                            locale={persian_fa}
                            disabled={mode == 'VIEW'}
                            autoFocus={mode == 'EDIT'}
                            ref={exprireDatePickerRef}
                            placeholder='-'


                        /> : '-'}


                    </div>

                    {/* {isAdmin && <div className="py-3 text-center col-span-1 text-gray-500 flex flex-row justify-center w-full items-center ">-</div>} */}



                    <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1">
                        <div className={"mt-1 flex justify-center"}>
                            <RenderRemainTime date={dates.residence?.toISOString() ?? ''} />
                            {/* {getRemainingTime(created_at).day} روز - {getRemainingTime(created_at).hour} ساعت - {getRemainingTime(created_at).minute} دقیقه */}
                        </div>
                    </div>

                    <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1 flex flex-row">

                        <DatePicker
                            value={dates.cross}
                            onChange={(e) => e ? setDates({ ...dates, cross: e.toDate() }) : undefined}
                            className='border'
                            inputClass={clsx('text-center rounded-lg w-full flex-none', mode == 'VIEW' ? 'border-transparent' : 'border !border-primary-300 ')}
                            containerClassName='odd'
                            calendar={persian}
                            format={"YYYY/MM/DD"}
                            locale={persian_fa}
                            disabled={mode == 'VIEW'}
                            placeholder='-'


                        />

                    </div>



                    <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1">
                        <div className={"mt-1 flex justify-center"}>
                            <RenderRemainTime date={dates.cross?.toISOString() ?? ''} />
                        </div>
                    </div>

                    <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1 flex flex-row gap-2 justify-center">
                        {!!dates?.passportPhoto && typeof dates.passportPhoto == 'string'
                            && <button className='bg-primary-300 rounded-lg text-white p-2 flex flex-row gap-1.5 items-center' onClick={() => window.open(`https://api.flysepehr.com/storage${dates.passportPhoto}`)}>{t('View')} <EyeIcon /></button>}

                        {mode == 'EDIT' && typeof dates.passportPhoto == 'string' && <label className='rounded-lg  border-primary-300 border text-primary-300 p-2 cursor-pointer'>
                            {/* <span>{t('ChoosePhoto')}</span> */}
                            <PenIcon className='size-5' />
                            <input type='file' accept='.pdf,.jpeg,.jpg,.png,.webm' hidden onChange={({ target: { files } }) => (files?.[0] instanceof File && mode == 'EDIT') ? setDates({ ...dates, passportPhoto: files?.[0] }) : undefined} />
                        </label>}


                        {mode == 'EDIT' && !!dates?.passportPhoto
                            && dates.passportPhoto instanceof File
                            && <button className='bg-orange-100 rounded-lg text-black p-2 flex flex-row gap-1.5 items-center'
                                onClick={() => dates.passportPhoto instanceof File ? window.open(URL.createObjectURL(dates.passportPhoto)) : undefined}>{t('PreviewSelectedFile')} <EyeIcon /></button>}

                        {mode == 'EDIT' ? !dates?.passportPhoto && <label className='rounded-lg  border-primary-300 border text-primary-300 p-2 cursor-pointer'>
                            <span>{t('ChoosePhoto')}</span>
                            <input type='file' accept='.pdf,.jpeg,.jpg,.png,.webm' hidden onChange={({ target: { files } }) => (files?.[0] instanceof File && mode == 'EDIT') ? setDates({ ...dates, passportPhoto: files?.[0] }) : undefined} />
                        </label> : ''}
                    </div>
                    {/* </div> */}
                    {/*<div className=" py-4  text-start text-gray-500 text-sm font-medium col-span-1">
          {
              
              <div className={"flex justify-center" }>
              <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
              {!(status === 0 || status === 1) ? <FormIconPure/> : <FormIcon/>}
              </div>
              </div>
            }
            
        </div> */}
                    {/*<div className={clsx("p-3 text-center col-span-1 flex flex-row gap-2 items-center ", isAgent ? 'justify-between' : 'justify-center')}>
                      
                            // (user?.role_key === "agent" || !!automation_number) ?
                            // <div className={"text-gray-500 text-sm mt-1 flex-1 text-center "}>
                            //     <div className={"flex gap-2 justify-center"}>
                            //         <span>{automation_number ?? '-'}</span>
                            //     </div>
                            // </div>
                            // :
                            // <div className={"text-gray-500 text-sm mt-1"}>
                            //     <div className={"flex gap-2 justify-center"}>
                            //         <span className={"w-[120px]"}>
                            //             <CustomInput
                            //                 placeHolder={t("automationNumber")}
                            //                 label={t("automationNumber")}
                            //                 name={"automationNumber" + id}
                            //                 onchange={(e: any) => setAtNumber(e?.value)}
                            //                 defaultValue={atNumber}
                            //                 disable={isLoadingProccess}
                            //             />
                            //         </span>
                            //         <div className={"w-[80px]"} onClick={(e) => e.stopPropagation()}>
                            //             {isLoadingProccess
                            //                 ? <div className='flex flex-row flex-1 justify-center items-center h-full'><Loading /></div>
                            //                 : <CustomButton

                            //                     onClick={() => {
                            //                         if (!atNumber) {
                            //                             return toast.info(t('automationNumberIsNotEntered'))
                            //                         }
                            //                         setSelected(true)
                            //                         // setId(item.id)
                            //                     }} styles={"text-sm"} title={t("save")} />}
                            //         </div>
                            //     </div>
                            // </div>
                        }

                        {/* <ChevronDown className={`transition-all duration-300 size-4 text-gray-700 shrink-0 ${isOpen ? '-rotate-180' : ''}`} /> 
                    </div>*/}

                    {
                        isAgent && <div className=" py-4 text-start text-gray-500 gap-4 items-center bg-transparent text-sm font-medium col-span-1 flex flex-row justify-center overflow-visible">

                            {mode == 'EDIT' && <div className='cursor-pointer' title={t('BackToView')} onClick={() => backToViewMode()}><TurnIcon className='size-5' /></div>}

                            {mode == 'EDIT' && <button
                                className={clsx('bg-primary-300 p-2 rounded-lg text-white px-6')}
                                // disabled={isEqualToRecent}
                                onClick={() => mutate()}
                            >{isLoading ? <Loading /> : t('confirmShort')}</button>}

                            {mode == 'VIEW' &&
                                <CrewVisaOperations isResidence={!!visa?.residence} onSuccessMutate={onSuccessMutate} agentVisaId={agent_visa_id} crewData={crews?.[0]} setMode={setMode} />}

                        </div>
                    }


                </div >
            </div >

            // </div >
        )

    }
    return <div className='border rounded-xl border-gray-400  flex flex-col  gap-2 mx-4 p-2 overflow-hidden text-center text-sm text-gray-500'> {t('visa')} ID = {id} {t('CrewIsEmpty')}</div>
}
